import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { take } from 'rxjs/operators';
import { LeasingComparablesRow } from '../../models/leasingcomparablesrow';
import { HttpClient } from '@angular/common/http';
import { AppServiceHelperService } from '../../../../../services/app-service-helper.service';
import { ObjectUtil } from '../../../../../components/common/object-util/object-util';

/**
 * LeasingComparables Widget
 */
@Component({
  selector: 'leasing-comparables-widget',
  templateUrl: './leasing-comparables-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './leasing-comparables-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LeasingComparablesWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Display values over time setting
   */
  public displayValuesOverTimeId: number = null;

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("leasingComparables", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('leasingcomparables').pipe(take(1));
    this.displayValuesOverTimeId = this.rdStorage.getDisplayValuesOverTimeId() || (!this.getReport() && 1);//setting to 1 for template mode

    if (!this.widgetConfig.widgetSettings.showButtonGetPixCompsData) {
      console.log('LeasingComparablesWidgetComponent: Upgrading widget settings: Set widgetConfig.widgetSettings.showButtonGetPixCompsData');
      this.widgetConfig.widgetSettings.showButtonGetPixCompsData = true;
    }

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('leasingcomparables', this.getReport()).pipe();
  }

  /**
   * Constructor
   * @param injector
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(injector: Injector, private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) {
    super(injector, 'leasingComparables', false);
  }

  /**
   * Add row
   */
  addRow() {
    if (!this.widgetData.rows) {
      this.widgetData.rows = [];
    }
    this.widgetData.rows.push(new LeasingComparablesRow());
    this.setDirtyFlag(true, true);
  }

  /**
   * Remove row
  * @param row {LeasingComparablesRow} Row to remove
   */
  removeRow(row: LeasingComparablesRow) {
    const index = this.widgetData.rows.indexOf(row, 0);
    if (index > -1) {
      this.widgetData.rows.splice(index, 1);
    }
    this.setDirtyFlag(true, true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Pre-process the loaded data.Override if needed
   * @param data The loaded data
   */
  protected preprocessLoadedData(data): any {
    if (this.displayValuesOverTimeId != 2) { return data; }

    try {
      for (const entry of data.rows) {
        //Data in DB is per year. Convert to per month for UI
        entry.rent /= 12;
      }
    } catch (e) {
      //Ignore
    }
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    const data = ObjectUtil.deepCopy(this.widgetData);//deep copy

    if (this.displayValuesOverTimeId === 2) {
      try {
        for (const entry of data.rows) {
          //Data in DB is per year. Convert from per month for saving
          entry.rent *= 12;
        }
      } catch (e) {
        //Ignore
      }
    }
    return data;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

  /**
 * Loads PixComps data
 */
  getPixCompsData() {
    this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', 'reportwidgets/leasingcomparables/getPixCompsData?oid=' + this.getReport()))
      .pipe(take(1)).subscribe((data) => {
        if (data == null || data.rows.length === 0) {
          this.eventBus.broadcastEvent("openConfirmDialog", {
            success: () => {
              //Nothing
            }
          }, 'infobarPixCompsDataNotAvailableConfirmDialog');
        } else {
          this.widgetData = null;
          setTimeout(() => {
            this.widgetData = data;

            this.setDirtyFlag(true, true);
          });
        }
      });
  }

}
